module.exports = __webpack_public_path__ + "img/search.6051ea46.svg";